/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-11 14:14:41
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2021-01-21 12:27:45
 */
let connectWebViewJavascriptBridge: (
  callback: (bridge: Window['WebViewJavascriptBridge']) => void
) => void
if (window.location.href.indexOf('iOS') !== -1) {
  // iOS13 及其以上版本
  connectWebViewJavascriptBridge = function(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    const WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function() {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
  connectWebViewJavascriptBridge(function(bridge) {
    bridge.registerHandler('JS Echo', function(data, responseCallback) {
      console.log('JS Echo called with:', data)
      responseCallback(data)
    })
    bridge.callHandler('ObjC Echo', { key: 'value' }, function responseCallback(
      responseData
    ) {
      console.log('JS received response:', responseData)
    })
  })
} else {
  // 安卓 和 iOS13 以下及其版本
  connectWebViewJavascriptBridge = function(callback) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function() {
          callback(window.WebViewJavascriptBridge)
        },
        false
      )
    }
  }
  connectWebViewJavascriptBridge(function(bridge) {
    bridge.init()
  })
}

let methodList: string[] = []

export async function callBridgeAsync(
  name: string,
  data: string | number | object = '',
  /**超时清除 */
  overtime = true,
  /**默认10s */
  overtimes = 10000
): Promise<any> {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  }

  return new Promise((resolve, reject) => {
    if (methodList.length) {
      if (!methodList.includes(name)) {
        return reject({
          code: '404',
          message: `应用异常：${name}未在宿主机注册`
        })
      }
    }

    const timer = overtime
      ? setTimeout(() => {
          console.log(name, '超时')
          reject('超时')
        }, overtimes)
      : 0
    connectWebViewJavascriptBridge(function(bridge) {
      bridge.callHandler(name, data, function(response) {
        if (typeof response == 'string') {
          try {
            response = JSON.parse(response)
          } catch (e) {
            console.log(`事件${name}响应为非json字符串`)
          }
        }
        if (process.env.NODE_ENV != 'production') {
          console.log(`事件${name}响应`, response)
        }
        overtime && clearTimeout(timer)
        if (response?.code && response.code != 200) {
          reject(response)
        }
        resolve(response)
      })
    })
  })
}

function callBridge(name: string, data: string | object = '') {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  }
  connectWebViewJavascriptBridge(function(bridge) {
    bridge.callHandler(name, data, function(response) {
      console.log(`事件${name}响应`, response)
    })
  })
}

export function callAppFunc_IsHiddenNavagationBar() {
  callBridge('appFunc_IsHideNavBar')
}

export function callAppFunc_getSomeParams() {
  return callBridgeAsync('appFunc_getSomeParams') as Promise<any>
}

/**
 * 设置导航颜色
 * @param navColor 16进制颜色 #FFFFFF
 */
export function callAppFunc_setNavColor(navColor: string) {
  callBridge('appFunc_setNavColor', navColor)
}

/**
 * 主动获取token
 */
export function callAppFunc_CacheToken() {
  return callBridgeAsync('appFunc_CacheToken') as Promise<any>
}

/**
 * 设置导航文字颜色
 */
export function callAppFunc_setTitleFontColor(color: string) {
  return callBridgeAsync('appFunc_setTitleFontColor', color) as Promise<any>
}

/**
 * 调用登陆
 * @param type
 */
export function callAppFunc_Jump2Act() {
  return callBridgeAsync('appFunc_Jump2Act') as Promise<any>
}

/**
 * 通知已签到
 */
export function callAppFunc_HasSignIn() {
  return callBridge('appFunc_HasSignIn')
}

/**
 * 下载
 */
export function callAppFunc_startToDownload(url: string) {
  return callBridgeAsync('appFunc_startToDownload', url)
}

/**
 * 下载
 */
export function callAppFunc_startDown(id: string | number) {
  return callBridgeAsync('appFunc_startDown', id)
}

/**
 * appFunc_dbSet
 */
export function callAppFunc_dbSet(data: { key: string | number; value: any }) {
  return callBridgeAsync('appFunc_dbSet', data)
}

/**
 * 获取wxcode
 */
export function callAppFunc_getWXCode() {
  return callBridgeAsync('appFunc_getWXCode', '', false)
}

/**
 * 获取App注册的所有方法名
 */
async function callAppFunc_getMethodList() {
  const res = await callBridgeAsync('appFunc_getMethodList')
  methodList = res.data.list
}

callAppFunc_getMethodList()

/**
 * 关闭当前webview弹窗
 */
export function closeWebViewPopUp() {
  return callBridgeAsync('appFunc_closeWebViewPopUp')
}

export function callAppFunc_dbGet(key: string | number) {
  return callBridgeAsync('appFunc_dbGet', key)
}
export function callAppFunc_dbDelete(key: string | number) {
  return callBridgeAsync('appFunc_dbDelete', key)
}

export function callAppFunc_installGame(key: string | number) {
  return callBridgeAsync('appFunc_installGame', key)
}
/**
 * 打开第三方App
 */
export function callAppFunc_webToThirdApp(data: {
  /**
   * app包名
   */
  appPackageName: 'com.inlive.phonelive'
  /**
   * 应用注册scheme地址，用于判断app是否安装，未安装跳appstore
   */
  schemeUrl?: 'taktak.tv://'
  /**
   * 应用App Store链接，用于ios跳转app store
   */
  appStoreUrl?: 'https://apps.apple.com/cn/app/taktak-%D8%A8%D9%89%DB%8B%D8%A7%D8%B3%D8%AA%DB%95-%D8%AA%D8%A7%D8%B1%D9%82%D9%89%D8%AA%D9%89%D8%B4/id1495740333'
  /**
   * 若为true则只跳应用市场
   */
  allToAppStore?: boolean
  /**
   * 打开app携带的数据
   */
  appData?: any
}) {
  return callBridgeAsync('appFunc_webToThirdApp', data)
}

/**
 * 拉起app版本更新弹窗
 * @returns
 */
export function callAppFunc_checkVersion(data: any) {
  return callBridge('appFunc_checkVersion', data)
}

/**
 * 返回app首页
 * @returns
 */
export function callAppFunc_goHome() {
  return callBridge('appFunc_goHome')
}

/**
 * 导航栏刷新按钮
 * @param state
 * @returns
 */
export function callAppFunc_showRefreshBtn(state: number) {
  console.log('appFunc_showRefreshBtn', state)
  return callBridge('appFunc_showRefreshBtn', { state })
}
